export const pluralize=(name,count)=>{return 1<count?name+"s":name};